import { useMemo } from 'react'
import styles from './index.module.scss'
import { getDigitalStore } from '@/store/digital'

export default function ShowMessage({
  isInScreen,
  isListening,
  isRecording,
  isTranscribing,
  isAgentProcessing
}: {
  isInScreen: boolean
  isListening: boolean
  isRecording: boolean
  isTranscribing: boolean
  isAgentProcessing: boolean
}) {

  const { isSpeaking } = getDigitalStore()
  const text = useMemo(() => {
    if (isSpeaking) {
      return '正在讲解...'
    }
    if (isTranscribing) {
      return '正在思考...'
    }
    if (isRecording) {
      return '正在倾听...'
    }
    if (isAgentProcessing) {
      return '正在思考...'
    }
    if (isListening) {
      return '正在倾听...'
    }
    return ''
  }, [isSpeaking, isTranscribing, isRecording, isAgentProcessing, isListening])

  if (!isInScreen || !text) {
    return null
  }
  return <div className={styles.showMessage}>
    <div>{text}</div>
  </div>
}


